import Box from '@mui/material/Box';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from '../../../../store';
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../../../util/apiClient';
import { deleteModuleDroit, IModuleDroit, setObjModuleDroit, setOpenDialogModuleDroit, setValueEdit } from './moduleDroitSlice';
import CommonListe from '../../../../components/Common/CommonListe';




const ListeModuleDroit = () => {


    //redux
    const dispatch = useDispatch()
    const {moduleDroits, objModuleDroit } = useSelector((state: IReduxState) => state.modulesDroit);

    
    const deleteItem = async (item: any) => {
        try {
            const apiPayload = { idModuleDroit: item.idModuleDroit }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/supprimermoduledroit", apiPayload)
            if (res.status === 1) {
                dispatch(deleteModuleDroit(item.idModuleDroit))
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddModuleDroit.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    };



    const handleEditDialogOpen = (item: IModuleDroit) => {
        dispatch(setOpenDialogModuleDroit(true))
        dispatch(setObjModuleDroit(item))
        dispatch(setValueEdit(item.libModuleDroit))
    }


    return (
        <Box sx={{ width: '100%',  bgcolor: 'background.paper' }}>
            <CommonListe
                data={moduleDroits}
                deleteItem={deleteItem}
                setItem={setObjModuleDroit}
                handleEditDialogOpen={handleEditDialogOpen}
            />
        </Box >
    );
}

export default ListeModuleDroit;
